import React, { FC } from "react";

import { Drawer } from "@components/common";
import { QuestionEditor } from "@components/main/questions";
import { useMultistepFormStore } from "@components/common/MultistepForm";
import { useUserStore } from "@store/user";
import { useCreateQuestionConfig } from "@api";

const CreateQuestionDrawer: FC = () => {
  const {
    createQuestionOpen,
    setCreateQuestionOpen,
    activeSection,
    formSettings: {
      formBasics: { id },
    },
  } = useMultistepFormStore();
  const { user } = useUserStore();
  const { createQuestionConfigEnabled } = useCreateQuestionConfig(user, id);

  return (
    createQuestionConfigEnabled &&
    activeSection && (
      <Drawer
        open={createQuestionOpen}
        onClose={() => setCreateQuestionOpen(false)}
        content={
          <QuestionEditor
            formId={id}
            formSection={activeSection}
            onSave={() => setCreateQuestionOpen(false)}
            onCancel={() => setCreateQuestionOpen(false)}
          />
        }
      />
    )
  );
};

export default CreateQuestionDrawer;
